import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import Button from '../orders/css';
import { getPdfUrl } from '../utils/utils';
import { orderStatus, fmFilterStatuses } from '../utils/constant';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import { useLocaleContext } from '../context/LocaleContext';
import EN from '../../EN.json';
import FR from '../../FR.json';

const getLink = (id, label) => {
  const locale = useLocaleContext();
  return (
    <a
      className="download-link"
      href={getPdfUrl(id, locale)}
      target="_blank"
      rel="noopener noreferrer"
    >
      {label}
    </a>
  );
};

const Tooltip = ({ children }) => {
  const localizedStrings = useLocalizedStringsContext();
  const { tooltipMessage } = localizedStrings.srtDashboard;
  return (
    <>
      {children}
      <div
        data-type="info"
        data-tip="React-tooltip"
        style={{ display: 'inline', marginLeft: '8px' }}
      >
        <i className="fa fa-question-circle"></i>
      </div>
      <ReactTooltip type="info" effect="float">
        {tooltipMessage}
      </ReactTooltip>
    </>
  );
};

Tooltip.propTypes = {
  children: PropTypes.node.isRequired
};

const getButton = (onClick, label, isDisabled) => (
  <Button onClick={onClick} disabled={isDisabled}>
    {label}
  </Button>
);

const getStatus = order => {
  const local = useLocaleContext();

  const {
    dashboardVUL: { status }
  } = local === 'en-US' ? EN : FR;
  // order = 'SUBMITTED'
  const incomplete = order === orderStatus.incomplete;
  const completed = order === orderStatus.submitted;
  const orderCanceled = order === orderStatus.canceled;

  const statusList = {
    [incomplete]: status.orderIncomplete,
    [completed]: status.orderCompleted,
    [orderCanceled]: status.orderCanceled
  };

  return statusList.true;
};

const exactCompareArray = (arrOne, arrTwo) => {
  return (
    arrOne.length === arrTwo.length &&
    arrOne.filter((currVal, idx) => currVal !== arrTwo[idx]).length === 0
  );
};

const getOrderType = (productSelected = []) => {
  const local = useLocaleContext();
  const {
    dashboardVUL: {
      microsoftLicensingFM,
      managedItServicesFM,
      fmProducts,
      orderType
    }
  } = local === 'en-US' ? EN : FR;
  let type = '';
  if (exactCompareArray(fmProducts, productSelected)) {
    type = orderType.fmProducts;
  } else if (exactCompareArray(microsoftLicensingFM, productSelected)) {
    type = orderType.microsoftLicensingFM;
  } else if (exactCompareArray(managedItServicesFM, productSelected)) {
    type = orderType.managedItServicesFM;
  } else {
    type = 'Vulcan';
  }
  return type;
};

const filterValueToStatusesMap = {
  [fmFilterStatuses.incomplete]: {
    orderStatus: orderStatus.incomplete
  },
  [fmFilterStatuses.submitted]: {
    orderStatus: orderStatus.submitted
  },
  [fmFilterStatuses.orderCanceled]: {
    orderStatus: orderStatus.canceled
  }
};

const getStatusFiltersPayload = filters => {
  const statuses = [];
  filters.forEach(element => {
    if (filterValueToStatusesMap[element.value]) {
      const correspondingOrderStatus =
        filterValueToStatusesMap[element.value].orderStatus;

      if (
        correspondingOrderStatus &&
        !statuses.includes(correspondingOrderStatus)
      )
        statuses.push(correspondingOrderStatus);
    }
  });
  return { status: statuses };
};

export { getLink, getButton, getStatus, getOrderType, getStatusFiltersPayload };
